/**
 * Mathematical Utility Functions
 * Provides rounding and calculation helpers for financial operations
 */

/**
 * Round number to specified decimal places
 * @param {number} value - Number to round
 * @param {number} decimals - Number of decimal places (default: 3)
 * @returns {number} - Rounded number
 */
export const roundTo = (value, decimals = 3) => {
    const num = parseFloat(value) || 0;
    return Math.round(num * Math.pow(10, decimals)) / Math.pow(10, decimals);
};

/**
 * Round for display (1 decimal place)
 * Use this for displaying currency values in UI
 * @param {number} value - Number to round
 * @returns {number} - Rounded number with 1 decimal place
 */
export const roundForDisplay = (value) => roundTo(value, 1);

/**
 * Round for calculation (1 decimal place)
 * Use this for intermediate calculations to prevent rounding error accumulation
 * @param {number} value - Number to round
 * @returns {number} - Rounded number with 1 decimal place
 */
export const roundForCalculation = (value) => roundTo(value, 1);

/**
 * Round percentage to 2 decimal places
 * @param {number} value - Percentage value to round
 * @returns {number} - Rounded percentage
 */
export const roundPercentage = (value) => roundTo(value, 2);
